import { useEffect, useState } from "react";

const defaultFullName = 'io.kiponos:sdk-boot-3:5.0.0.260710'; // Hardcoded fallback if /latest-sdk proxy fails

export default function useLatestSdk() {
  const [group, setGroup] = useState(null);
  const [artifact, setArtifact] = useState(null);
  const [version, setVersion] = useState(null);
  const [fullName, setFullName] = useState(null);

  //------ Effect ------
  //
  useEffect(() => { 
    fetch('/latest-sdk') // https://kiponos.io/latest-sdk → nginx → repo1 maven-metadata.xml
      .then(response => response.text())
      .then(xmlString => {
        // Extract groupId, artifactId, and latest version
        const groupMatch = xmlString.match(/<groupId>(.*?)<\/groupId>/);
        const artifactMatch = xmlString.match(/<artifactId>(.*?)<\/artifactId>/);
        const latestMatch = xmlString.match(/<latest>(.*?)<\/latest>/);

        if (groupMatch) {
          setGroup(groupMatch[1]); // e.g., "io.kiponos"
        }

        if (artifactMatch) {
          setArtifact(artifactMatch[1]); // e.g., "sdk-boot-3"
        }

        if (latestMatch) {
          setVersion(latestMatch[1]); // e.g., "5.0.0.260710"
        }

        // If any of the matches are null, return the default full name
        const fullName = groupMatch && artifactMatch && latestMatch 
          ? `${groupMatch[1]}:${artifactMatch[1]}:${latestMatch[1]}` 
          : defaultFullName;

        setFullName(fullName);
      })
      .catch(error => {
        console.error('Error fetching latest SDK version:', error);
        setFullName(defaultFullName);
      });
  },[]);


  //------ Return ------

  return {
    group,
    artifact,
    version,
    fullName,
    loading: !fullName,
  }
}
